import { StackProps } from "@chakra-ui/layout";
import { Tag, TagLabel, TagProps } from "@chakra-ui/tag";
import { AVATAR_CARD_MODES } from "@components/Cards/AvataraCard/AvatarCard";
import React, { forwardRef } from "react";

export const RTag = forwardRef<TagProps, "div">(({ children, id, ...props }: any, ref) => (
    <Tag ref={ref} key={id} size="sm" borderRadius="none" variant="solid" color="#71869E" cursor="pointer"
                backgroundColor="#E7F2FF" px="8px" py="6px" mr="5px" mb="5px" {...props}>
        <TagLabel textTransform="uppercase" fontSize="12px">{children}</TagLabel>
    </Tag>
));